export default "__VITE_ASSET__Duq$NNaS__"